<template>
  <v-layout>
    <v-flex xs11>
      <div style="margin:50px 0px 15px 50px;">
        <p>{{ theLabel }}</p>
         <!--<v-textarea outline v-model="value" no-resize :change="onValueChanged"></v-textarea>-->
        <textarea-autosize
          autosize
          class="comment-box"
          v-model="value"
          :min-height="200"
          :max-height="400"
					id="explanation"
        />
        <br /><br />
      </div>
    </v-flex>
    <v-flex xs1 />
  </v-layout>
</template>

<script>
export default {
  name: "AnswerExplaination",
  props: {
    label: String,
    explanation: String
  },
  computed: {
		value: {
			get: function () {
				return this.explanation;
			},
			set: function (newVal) {
       this.$emit('update', { exp: newVal });
			}
		},
    theLabel: function () {
      if (!this.label) { return 'If needed, use the space below to provide clarification for the data reported in this question.'; }
      return this.label;
    }
  }
};
</script>

<style scoped>
  .comment-box {
    min-width: 100%;
    background: white;
  }
</style>
